import React, { } from "react";
import { IoEyeSharp } from "react-icons/io5";
import BrandComponents from "../../Masters/Brand/BrandComponents";

function DcTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "Status", field: "status" },
    { label: "DC Type", field: "deliverychallantype" },
    { label: "DC Category", field: "deliverychallancategory" },
    { label: "Delivery Note No", field: "deliverynoteno" },
    { label: "Delivery Note Date", field: "deliverynotedate" },
    { label: "Customer", field: "customer" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"Delivery Challan "}
        apiField={"deliveryChallan"}
        addButton={"+ ADD"}
        createRoute={"/dcCreate"}
        updateRoute={"/dcView"}
        viewRoute={"/dcView"}
      />
    </div>
  );
}

export default DcTable;
